import React, { useEffect } from 'react';
import { fetchAuthenticated } from 'services/fetch';
import { CommonButton } from 'components/buttons/ButtonsForm';
import { emitEvent } from 'utils/events';
import NewRfImportForm from 'components/forms/NewRfImportForm';
import { getItem } from 'services/local-storage';

const GESTAO_CHIPS_FILE_ACCEPT = '.txt,text/plain';

export default function NewGestaoChips(props) {
  const { history, setBreadcrumbs } = props;

  useEffect(() => {
    setBreadcrumbs([
      { path: '/cadastros/gestao-chips', label: 'Gestão de Chips' },
      { path: '', label: 'Nova importação' },
    ]);
    return () => setBreadcrumbs([]);
  }, [setBreadcrumbs]);

  const downloadTemplate = async () => {
    const user = getItem('user');
    const base = process.env.REACT_APP_SERVER_URL || '';
    const res = await fetch(`${base}gestao-chips-import/template/txt`, {
      method: 'GET',
      headers: {
        ...(user && user.accessToken
          ? { Authorization: `Bearer ${user.accessToken}` }
          : {}),
      },
    });
    if (!res.ok) {
      emitEvent('showSnack', {
        message: 'Não foi possível baixar o modelo',
        type: 'error',
      });
      return;
    }
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'gestao-chips-template.txt';
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  const handleSubmit = async data => {
    if (data.description === '') {
      return;
    }
    if (JSON.stringify(data.file) === '{}') {
      return;
    }

    const response = await fetchAuthenticated(
      'post',
      'gestao-chips-import',
      data
    );

    if (!response.ok) {
      throw new Error('');
    }
    const created = await response.json();
    emitEvent('showSnack', {
      message: 'Importação registrada. O processamento será feito em breve.',
      type: 'success',
    });
    history.push('/cadastros/gestao-chips');
  };

  const handleCancel = () => {
    history.push('/cadastros/gestao-chips');
  };

  const templateButton = (
    <CommonButton
      label="Baixar modelo (.txt)"
      color="primary"
      onClick={downloadTemplate}
    />
  );

  return (
    <div>
      <NewRfImportForm
        title="Nova importação"
        titleAccessory={templateButton}
        handleCancel={handleCancel}
        handleSubmit={handleSubmit}
        fileAccept={GESTAO_CHIPS_FILE_ACCEPT}
        fileInputId="gestaoChipsTxtUpload"
      />
    </div>
  );
}
